import React from "react";
import ReactDOM from "react-dom";
import createReactClass from "create-react-class";
import "react-select/dist/react-select.css";
import "./css/react-confirm-alert.css";
import "./css/bootstrap-multiselect.css";
import "./css/toastr.min.css";
import "./css/animate.min.css";
import "./style.css";
import {
  ContratadosCreateForm,
  ContratadosEditForm,
  Contratados,
  Distratos,
  DistratosCreateForm,
  DistratosEditForm,
  ContratadosTrash,
  UnidadesEditForm,
  UnidadesCreateForm,
  UnidadesOrcamentarias,
  UnidadesOrcamentariasTrash,
  GestoresEditForm,
  GestoresCreateForm,
  Gestores,
  GestoresTrash,
  FiscaisEditForm,
  FiscaisCreateForm,
  Fiscais,
  FiscaisTrash,
  Contratos,
  ContratosTrash,
  ContratosManageForm,
  ContratosCreateForm,
  ContratosEditForm,
  Fiscalizacao,
  AtaReuniao,
  AtaReuniaoTrash,
  AtaReuniaoEditForm,
  AtaReuniaoCreateForm,
  DiarioOcorrencias,
  DiarioOcorrenciasCreateForm,
  DiarioOcorrenciasEditForm,
  DiarioOcorrenciasTrash,
  ProrrogacaoContratual,
  ProrrogacaoContratualCreateForm,
  ProrrogacaoContratualEditForm,
  ProrrogacaoContratualTrash,
  Notificacao,
  NotificacaoCreateForm,
  NotificacaoEditForm,
  NotificacaoTrash,
  TermoCircunstanciado,
  TermoCircunstanciadoCreateForm,
  TermoCircunstanciadoEditForm,
  TermoCircunstanciadoTrash,
  NotasFiscais,
  NotasFiscaisEditForm,
  NotasFiscaisTrash,
  Dashboard,
  Relatorios,
  LoginForm,
  Logout,
  PersonalizarRelatorios,
  Usuarios,
  UsuariosCreateForm,
  UsuariosEditForm,
  Digitalizados,
  DigitalizadosCreateForm,
  DigitalizadosTrash,
  Aditivos,
  AditivosCreateForm,
  AditivosEditForm,
  AditivosTrash,
  ImportacaoTCE,
  RelatorioLogs,
  ReciboDeAtestoDeServicoForm,
  RelatorioRecibos,
  Documentos,
  DistratosDigitalizados,
  DistratosDigitalizadosCreateForm,
  DistratosDigitalizadosTrash,
} from "./views";
import Layout from "./views/Layout";
import registerServiceWorker from "./registerServiceWorker";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import * as constants from "./constants";
import { HttpError } from "./components";
import "./index.css";
import "./css/style.css";
import "./css/bootstrap.min.css";
import "./css/material-dashboard.css";
constants.init();
function loggedIn() {
  if (!localStorage.me) {
    return false;
  }
  if (!localStorage.token) {
    return false;
  }
  return localStorage.getItem("token") !== "null";
}
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      loggedIn() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);
var NotFound = createReactClass({
  render: function () {
    return (
      <Layout>
        <HttpError message="Página não encontrada" status={404} />
      </Layout>
    );
  },
});
const LoginRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      loggedIn() ? (
        <Redirect
          to={{
            pathname: "/",
            state: { from: props.location },
          }}
        />
      ) : (
        <Component {...props} />
      )
    }
  />
);

ReactDOM.render(
  <Router onUpdate={() => window.scrollTo(0, 0)}>
    <Switch>
      <PrivateRoute exact path="/" component={Dashboard} />
      <PrivateRoute
        exact
        path="/personalizarelatorios"
        component={PersonalizarRelatorios}
      />
      <PrivateRoute
        exact
        path="/recibodeatestodeservico"
        component={ReciboDeAtestoDeServicoForm}
      />
      <PrivateRoute exact path="/fiscalizacao" component={Fiscalizacao} />
      <PrivateRoute
        exact
        path="/prorrogacaocontratual"
        component={ProrrogacaoContratual}
      />
      <PrivateRoute
        exact
        path="/prorrogacaocontratual/trash"
        component={ProrrogacaoContratualTrash}
      />
      <PrivateRoute
        exact
        path="/prorrogacaocontratual/create"
        component={ProrrogacaoContratualCreateForm}
      />
      <PrivateRoute
        exact
        path="/prorrogacaocontratual/edit/:id"
        component={ProrrogacaoContratualEditForm}
      />

      <PrivateRoute
        exact
        path="/termocircunstanciado"
        component={TermoCircunstanciado}
      />
      <PrivateRoute
        exact
        path="/termocircunstanciado/trash"
        component={TermoCircunstanciadoTrash}
      />
      <PrivateRoute
        exact
        path="/termocircunstanciado/create"
        component={TermoCircunstanciadoCreateForm}
      />
      <PrivateRoute
        exact
        path="/termocircunstanciado/edit/:id"
        component={TermoCircunstanciadoEditForm}
      />

      <PrivateRoute
        exact
        path="/solicitacaoesclarecimento"
        component={Notificacao}
      />
      <PrivateRoute
        exact
        path="/solicitacaoesclarecimento/trash"
        component={NotificacaoTrash}
      />
      <PrivateRoute
        exact
        path="/solicitacaoesclarecimento/create"
        component={NotificacaoCreateForm}
      />
      <PrivateRoute
        exact
        path="/solicitacaoesclarecimento/edit/:id"
        component={NotificacaoEditForm}
      />

      <PrivateRoute
        exact
        path="/diarioocorrencias"
        component={DiarioOcorrencias}
      />
      <PrivateRoute
        exact
        path="/diarioocorrencias/trash"
        component={DiarioOcorrenciasTrash}
      />
      <PrivateRoute
        exact
        path="/diarioocorrencias/create"
        component={DiarioOcorrenciasCreateForm}
      />
      <PrivateRoute
        exact
        path="/diarioocorrencias/edit/:id"
        component={DiarioOcorrenciasEditForm}
      />

      <PrivateRoute exact path="/atareuniao" component={AtaReuniao} />
      <PrivateRoute
        exact
        path="/atareuniao/trash"
        component={AtaReuniaoTrash}
      />
      <PrivateRoute
        exact
        path="/atareuniao/create"
        component={AtaReuniaoCreateForm}
      />
      <PrivateRoute
        exact
        path="/atareuniao/edit/:id"
        component={AtaReuniaoEditForm}
      />

      <PrivateRoute exact path="/relatorios" component={Relatorios} />
      <PrivateRoute exact path="/documentos" component={Documentos} />
      <PrivateRoute exact path="/contratos" component={Contratos} />
      <PrivateRoute exact path="/contratos/trash" component={ContratosTrash} />
      <PrivateRoute
        exact
        path="/contratos/create"
        component={ContratosCreateForm}
      />
      <PrivateRoute
        exact
        path="/contratos/edit/:id"
        component={ContratosEditForm}
      />
      <PrivateRoute
        exact
        path="/contratos/gerenciar/:id"
        component={ContratosManageForm}
      />

      <PrivateRoute exact path="/aditivos/:id" component={Aditivos} />
      <PrivateRoute
        exact
        path="/aditivos/create/:id"
        component={AditivosCreateForm}
      />
      <PrivateRoute
        exact
        path="/aditivos/edit/:id"
        component={AditivosEditForm}
      />
      <PrivateRoute exact path="/aditivosTrash" component={AditivosTrash} />

      <PrivateRoute exact path="/fiscais" component={Fiscais} />
      <PrivateRoute exact path="/fiscais/trash" component={FiscaisTrash} />
      <PrivateRoute
        exact
        path="/fiscais/create"
        component={FiscaisCreateForm}
      />
      <PrivateRoute
        exact
        path="/fiscais/edit/:id"
        component={FiscaisEditForm}
      />

      <PrivateRoute exact path="/usuarios" component={Usuarios} />
      <PrivateRoute
        exact
        path="/usuarios/create"
        component={UsuariosCreateForm}
      />
      <PrivateRoute
        exact
        path="/usuarios/edit/:id"
        component={UsuariosEditForm}
      />

      <PrivateRoute exact path="/gestores" component={Gestores} />
      <PrivateRoute exact path="/gestores/trash" component={GestoresTrash} />
      <PrivateRoute
        exact
        path="/gestores/create"
        component={GestoresCreateForm}
      />
      <PrivateRoute
        exact
        path="/gestores/edit/:id"
        component={GestoresEditForm}
      />

      <PrivateRoute exact path="/contratados" component={Contratados} />
      <PrivateRoute
        exact
        path="/contratados/trash"
        component={ContratadosTrash}
      />
      <PrivateRoute
        exact
        path="/contratados/create"
        component={ContratadosCreateForm}
      />
      <PrivateRoute
        exact
        path="/contratados/edit/:id"
        component={ContratadosEditForm}
      />
      <PrivateRoute exact path="/distratos" component={Distratos} />
      <PrivateRoute
        exact
        path="/distratos/create"
        component={DistratosCreateForm}
      />
      <PrivateRoute
        exact
        path="/relatoriorecibos"
        component={RelatorioRecibos}
      />
      <PrivateRoute
        exact
        path="/distratos/edit/:id"
        component={DistratosEditForm}
      />
      <PrivateRoute exact path="/digitalizados/:id" component={Digitalizados} />
      <PrivateRoute
        exact
        path="/digitalizados/:id/trash"
        component={DigitalizadosTrash}
      />
      <PrivateRoute
        exact
        path="/digitalizados/:id/create"
        component={DigitalizadosCreateForm}
      />

      <PrivateRoute exact path="/unidades" component={UnidadesOrcamentarias} />
      <PrivateRoute
        exact
        path="/unidades/trash"
        component={UnidadesOrcamentariasTrash}
      />
      <PrivateRoute
        exact
        path="/unidades/create"
        component={UnidadesCreateForm}
      />
      <PrivateRoute
        exact
        path="/unidades/edit/:id"
        component={UnidadesEditForm}
      />
      <PrivateRoute exact path="/tce" component={ImportacaoTCE} />
      <PrivateRoute exact path="/notas/:id" component={NotasFiscais} />
      <PrivateRoute exact path="/logs" component={RelatorioLogs} />

      <PrivateRoute
        exact
        path="/notas/trash/:id"
        component={NotasFiscaisTrash}
      />
      <PrivateRoute
        exact
        path="/notas/edit/:id"
        component={NotasFiscaisEditForm}
      />
      <PrivateRoute
        exact
        path="/distrato_digitalizados/:id"
        component={DistratosDigitalizados}
      />
      <PrivateRoute
        exact
        path="/distrato_digitalizados/:id/trash"
        component={DistratosDigitalizadosTrash}
      />
      <PrivateRoute
        exact
        path="/distrato_digitalizados/:id/create"
        component={DistratosDigitalizadosCreateForm}
      />
      <Route exact path="/logout" component={Logout} />
      <LoginRoute exact path="/login" component={LoginForm} />
      <Route component={NotFound} />
    </Switch>
  </Router>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js